import { createAsyncThunk } from '@reduxjs/toolkit';
import { getJydacomReportStatus } from '../services/getJydacomReportStatus.service';

const POLL_INTERVAL_MS = 3000;
const MAX_POLL_ATTEMPTS = 40;

export const pollSalaryTransferStatus = createAsyncThunk(
  'reports/pollSalaryTransferStatus',
  async ({ projectId, reportId }, { rejectWithValue }) => {
    let attempts = 0;

    while (attempts < MAX_POLL_ATTEMPTS) {
      attempts += 1;

      const statusResponse = await getJydacomReportStatus(
        projectId,
        reportId
      );

      const transferStatus = statusResponse?.status;

      if (transferStatus === 'COMPLETED') {
        return { status: 'COMPLETED', data: statusResponse };
      }

      if (transferStatus === 'ERROR') {
        let errorPayload;

        try {
          errorPayload =
            typeof statusResponse?.errorMessage === 'string'
              ? JSON.parse(statusResponse.errorMessage)
              : statusResponse?.errorMessage;
        } catch {
          errorPayload = { message: statusResponse?.errorMessage };
        }

        return rejectWithValue({
          status: 'ERROR',
          errorType: errorPayload?.errorType,
          items: errorPayload?.items,
          worksiteCodes: errorPayload?.worksiteCodes,
          message: errorPayload?.message || statusResponse?.errorMessage,
          data: statusResponse,
        });
      }

      // Still in progress — wait and poll again
      await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
    }

    // Exceeded max attempts
    return rejectWithValue({
      status: 'TIMEOUT',
      message: 'Transfer status polling timed out',
    });
  }
);
